import React from "react";
import "../../styles/components/PrivacyPolicy.css";

export default function PrivacyPolicyPage() {
  return (
    <section className="pp">
      <div className="pp__wrap" role="document" aria-label="Privacy Policy">
        <h1 className="pp__title">Privacy Policy</h1>
        <p className="pp__meta">Effective Date: <span>[Month DD, YYYY]</span></p>
        <p className="pp__intro">
          Welcome to [Your Website Name]. We are committed to protecting your personal information
          and your right to privacy. If you have any questions about this policy, feel free to
          contact us at [your email address].
        </p>

        <h2 className="pp__h2">1. WHAT INFORMATION WE COLLECT</h2>
        <p>We may collect the following types of personal information:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number (if provided)</li>
          <li>IP address</li>
          <li>Usage data (e.g. pages visited, time spent, interactions)</li>
        </ul>
        <p>We only collect data that is necessary to provide and improve our services.</p>

        <h2 className="pp__h2">2. HOW WE COLLECT INFORMATION</h2>
        <p>We collect information when you:</p>
        <ul>
          <li>Fill out forms on our site</li>
          <li>Contact us via email or chat</li>
          <li>Use or browse our website</li>
          <li>Subscribe to our newsletter</li>
        </ul>
        <p>
          We may also use cookies and tracking tools (e.g. Google Analytics) to analyze site usage.
        </p>

        <h2 className="pp__h2">3. HOW WE USE YOUR INFORMATION</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Respond to inquiries</li>
          <li>Provide and improve our services</li>
          <li>Send occasional updates (if subscribed)</li>
          <li>Analyze site usage and improve performance</li>
          <li>Comply with legal obligations</li>
        </ul>
        <p>We do not sell or share your personal data with third parties for marketing.</p>

        <h2 className="pp__h2">4. COOKIES</h2>
        <p>
          We use cookies to improve your browsing experience and gather analytics. You can disable
          cookies through your browser settings at any time.
        </p>

        <h2 className="pp__h2">5. THIRD-PARTY SERVICES</h2>
        <p>
          We may use third-party tools (such as Google Analytics or email services) that process
          data on our behalf. These services follow their own privacy policies.
        </p>

        <h2 className="pp__h2">6. HOW WE PROTECT YOUR DATA</h2>
        <p>
          We implement reasonable technical and organizational measures to protect your data.
          However, no online system is 100% secure, and we cannot guarantee absolute security.
        </p>

        <h2 className="pp__h2">7. YOUR RIGHTS</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent (where applicable)</li>
        </ul>
        <p>To exercise these rights, contact us at [your email address].</p>

        <h2 className="pp__h2">8. CHANGES TO THIS POLICY</h2>
        <p>
          We may update this Privacy Policy from time to time. All changes will be posted on this
          page with an updated effective date.
        </p>

        <h2 className="pp__h2">9. CONTACT US</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at
          [your email address].
        </p>
      </div>
      
    </section>
  );
}
